import 'vite/modulepreload-polyfill';
import { createRoot } from 'react-dom/client';
import { Subscriptions } from "./Components/Subscriptions.jsx";


const container = document.getElementById('subscriptions');
const root = createRoot(container);
const configuration = JSON.parse(document.getElementById('subscriptions-config').innerText);


root.render((
       <Subscriptions configuration={configuration} />
));
